module.exports = __webpack_public_path__ + "static/media/EV3.347d60a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EV3.jpg
// module id = 185
// module chunks = 0